import React from 'react'

export const IconArrowDown = (props: React.SVGAttributes<any>) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-arrow-down"
      {...props}
    >
      <polyline points="19 12 12 19 5 12" />
    </svg>
  )
}
